import { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useAttribution } from 'app/components/analytics-attribution/useAttribution'
import { AttributionShadcnComponent } from 'app/components/analytics-attribution/AttributionShadcnComponent'
import { useCheckPermission } from 'app/hooks/useCheckPermission'
import { UserPermissionsContext } from 'app/hooks/useUserPermission'
import { useUser } from 'app/utils'
import { isSMCOrg } from 'lib/isSMCOrg'

export default observer(function Attribution() {
  const user = useUser()
  const checkPermission = useCheckPermission()
  const { permissions } = useContext(UserPermissionsContext)
  const hookData = useAttribution()

  if (!user) return null

  // SMC orgs never have access to attribution
  if (isSMCOrg(user.orgId)) {
    return <Navigate to="/" replace />
  }

  if (permissions === undefined) return null // Wait for permissions to load
  if (!checkPermission([`org:pages:analytics:attribution`, `pages:analytics`])) {
    return <Navigate to="/analytics/marketing" replace />
  }

  return <AttributionShadcnComponent {...hookData} />
})
